export default __webpack_public_path__ + "static/media/apostar_icons_white_apotheke_datenaendern.cfbe6f73.svg";